

























import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import PicUpload from "@/components/picUpload/index.vue";
import questionSettingTemplate from "./questionSettingTemplate.vue";

@Component({
  name: "cascade",
  components: {
    PicUpload,
    questionSettingTemplate,
  },
  filters: {},
})
export default class cascade extends Vue {
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  value!: any;
  @Prop({
    type: Boolean,
    default: false,
  })
  disabled?: any;

  @Watch("value", { deep: true, immediate: true })
  watchPropData() {
    if (JSON.stringify(this.value) != JSON.stringify(this.postForm)) {
      this.postForm = JSON.parse(JSON.stringify(this.value));
      this.clearValidate();
      this.$nextTick(() => {
        this.validate();
      });
    }
  }
  private postForm = {
    title: "请选择以下选项", // 标题
    required: "1", // 是否必填
  };

  private rules = {
    title: [{ required: true, min: 0, max: 15, message: "请输入题目标题", trigger: "blur" }],
    required: [{ required: true, message: "请选择是否必填", trigger: "blur" }],
  };
  @Watch("postForm", { deep: true })
  watchPostForm() {
    const backup = JSON.parse(JSON.stringify(this.postForm));
    this.$emit("input", backup);
    this.$emit("change", backup);
  }

  getFormInstance() {
    return this.$refs.postForm as any;
  }
  async validate() {
    return await this.getFormInstance()
      .validate()
      .catch((err: any) => {
        return err;
      });
  }
  clearValidate() {
    if (this.getFormInstance()) {
      this.getFormInstance().clearValidate();
    }
  }
}
